import { Fragment } from 'react';

import useOrgUnitAdminContacts from './UseOrgUnitAdminContacts';

import OrgUnitAdminContactsGrid from './OrgUnitAdminContactsGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const OrgUnitAdminContactsReadOnly = () => {
  const {
    omeMeetOrgUnitContactState,
    isLoading,
    Constants
  } = useOrgUnitAdminContacts();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H5>Entry Contacts</Headings.H5>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className='col-xs-12'>
          <OrgUnitAdminContactsGrid
            gridData={omeMeetOrgUnitContactState.arrayData}
            isLoading={omeMeetOrgUnitContactState.isArrayLoading}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment >
  );
};

export default OrgUnitAdminContactsReadOnly;